import React, { FC, Fragment, ReactNode, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import { Divider, List, ListItem, ListItemText, Typography } from '@material-ui/core';

import { isPathMatch } from 'utilities';
import { ILink } from '../../types';

const useStyles = makeStyles(theme => ({
  search: {
    paddingLeft: 28,
    paddingRight: 28,
  },
  list: {
    width: 300,
    paddingLeft: 16,
    paddingRight: 16,
    paddingBottom: 16,
  },
  listItem: {
    paddingTop: 12,
    paddingBottom: 12,
    marginTop: 8,
    marginBottom: 8,
    borderRadius: 4,
  },
  active: {
    color: theme.palette.primary.main,
  },
}));

interface Props {
  links: ILink[];
  search: ReactNode;
  onNavigate: () => void;
}

const Drawer: FC<Props> = ({ links, search, onNavigate }) => {
  const classes = useStyles();
  const history = useHistory();
  const { t } = useTranslation();

  useEffect(() => {
    const unlisten = history.listen(() => onNavigate());
    return () => unlisten();
  });

  function renderDrawerListItem(link: ILink) {
    const { i18nKey, component, matchPaths } = link;
    const isActive = isPathMatch(matchPaths, window.location.pathname);

    return (
      <ListItem
        button
        key={i18nKey}
        className={classes.listItem}
        selected={isActive}
        component={component}
      >
        <ListItemText disableTypography>
          <Typography variant="subtitle2">{t(i18nKey)}</Typography>
        </ListItemText>
      </ListItem>
    );
  }

  return (
    <Fragment>
      <div className={classes.search}>{search}</div>
      <Divider />
      <List className={classes.list}>{links.map(renderDrawerListItem)}</List>
    </Fragment>
  );
};

export default Drawer;
